<div class="flex flex-col gap-6 min-w-0 overflow-x-auto h-full">
    <div class="flex items-center gap-3 shrink-0">
        <p-progress-spinner *ngIf="loading()" strokeWidth="5" [style]="{ width: '25px', height: '25px' }" />
    </div>

    <div class="flex-1 min-h-0 relative" style="min-height: 200px;">
        <p-chart type="bar" [data]="chartData()" [options]="chartOptions"></p-chart>
    </div>
</div>
